import { createFileRoute } from '@tanstack/react-router'
import Documentation from 'Administration/components/system/Documentation'

export const Route = createFileRoute('/administration/integrations/documentation')({
    component: Documentation,
})
